module.exports = __webpack_public_path__ + "img/logo-ct.11e796dc.png";